import { RobotoFont } from 'src/styles/fonts';
import styled from '@emotion/styled';

export const Container = styled.div`
  margin: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: 400;
  font-famnily: ${RobotoFont.style.fontFamily}, sans-serif;
  color: #c8c8c8;
  width: 100%;
  background: #ffffff;

  .contact-us-block {
    font-family: ${RobotoFont.style.fontFamily}, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: #c8c8c8;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-block: 24px;
    width: 100%;
    text-align: center;
  }

  .callback-link {
    width: 102px;
    font-family: ${RobotoFont.style.fontFamily}, sans-serif;
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 24px;
    color: #263f95;
    transform: rotate(-0.28deg);
  }

  .contact-us-text-area {
    margin-top: 9px !important;
  }

  .info-block {
    font-family: Verdana;
    font-size: 12px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    padding-inline: 48px;
    margin-bottom: 24px;
    white-space: nowrap;
    text-align: center;

    @media only screen and (max-width: 500px) {
      padding-inline: 0;
    }

    span {
      sursor: pointer;
    }

    a,
    a:hover,
    a:focus,
    a:active {
      text-decoration: none;
      color: inherit;
    }
  }

  .or {
    position: relative;
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .or::before,
  .or::after {
    content: ' ';
    position: absolute;
    display: block;
    top: 50%;
    transform: translateY(-50%);
  }

  // .or::before {
  //   background-color: #ffffff;
  //   height: 8px;
  //   width: 100px;
  //   z-index: -1;
  // }

  .or::after {
    background-color: #e5e6e7;
    height: 2px;
    width: 100%;
    z-index: -2;
  }

  .form-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    row-gap: 15px;
    width: 100%;
    padding-inline: 60px;
    min-width: 299px;
  }

  .form-row-order {
    @media only screen and (max-width: 768px) {
      padding-inline: 13px;
    }
  }

  .contact-us-row {
    row-gap: 18px;
    @media only screen and (max-width: 768px) {
      padding-inline: 37.5px;
    }
  }

  .input-wrapper {
    flex: 1;
    display: flex;
    flex-direction: column;
    width: 100%;
    min-width: 300px;
  }

  .form-label {
    color: #0d0d0e;
    font-size: 24px;
    font-weight: 700;
    margin: 0 0 24px 0;
    align-self: center;
  }

  .input-label,
  .info-label {
    font-family: 'Verdana';
    font-style: normal;
    color: #7d8286;
    font-size: 12px;
    font-weight: 400;
    margin: 12px 0 8px 0;
  }

  .info-label {
    padding-bottom: 24px;
  }

  .custom-input,
  .custom-select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    max-height: 44px;
    ::-webkit-input-placeholder {
      font-family: ${RobotoFont.style.fontFamily}, sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 20px;
      color: #c8c8c8;
    }

    ::-moz-placeholder {
      font-family: ${RobotoFont.style.fontFamily}, sans-serif;
    }

    font-family: ${RobotoFont.style.fontFamily}, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    border: 1px solid #d7d7d7;
    padding: 12px 20px;
    border-radius: 2px;
    outline: none;
    flex: 1;
    color: #c8c8c8;
    margin: 0;
  }

  .buttons {
    display: flex;
    width: 100%;
    gap: 15px;
    align-items: center;
    justify-content: center;
  }

  .buttonsCallback {
    display: flex;
    width: 100%;
    gap: 15px;
    align-items: center;
    justify-content: center;
    margin: 13px 0 48px;
  }

  .buttonsOrder {
    display: flex;
    width: 100%;
    gap: 15px;
    align-items: center;
    justify-content: center;
    margin: 33px 0 48px;
    @media only screen and (max-width: 768px) {
      margin: 0;
    }
  }

  .custom-input {
    @media only screen and (max-width: 280px) {
      width: 192px;
    }
    .PhoneInputCountrySelect {
      overflow: auto;
      overflow-y: auto;
      height: 50px;

      ::-webkit-scrollbar {
        width: 6px;
        height: 6px;
      }

      ::-webkit-scrollbar-track {
        border-radius: 5px;
        background-color: #e4e6ef;
      }

      ::-webkit-scrollbar-thumb {
        border-radius: 5px;
        background-color: #cccccc;
      }

      scrollbar-width: 6px;
      scrollbar-height: 6px;
      scrollbar-color: #cccccc #e4e6ef;
    }

    input {
      outline: none;
      border: none;
      font-family: ${RobotoFont.style.fontFamily}, sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 20px;
      color: #c8c8c8;
    }

    select {
      max-height: 130px;
    }
  }
  .custom-input:hover {
    @media only screen and (max-width: 280px) {
      width: 192px;
    }
    .PhoneInputCountrySelect {
      overflow: auto;
      overflow-y: auto;
      height: 50px;

      ::-webkit-scrollbar {
        width: 6px;
        height: 6px;
      }

      ::-webkit-scrollbar-track {
        border-radius: 5px;
        background-color: #e4e6ef;
      }

      ::-webkit-scrollbar-thumb {
        border-radius: 5px;
        background-color: #cccccc;
      }

      scrollbar-width: 6px;
      scrollbar-height: 6px;
      scrollbar-color: #cccccc #e4e6ef;
    }

    input {
      outline: none;
      border: none;
      font-family: ${RobotoFont.style.fontFamily}, sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 20px;
      color: #c8c8c8;
    }

    select {
      max-height: 130px;
    }
    border: 1px solid #535353;
  }

  .custom-button {
    display: block;
    background-color: #0d0d0e;
    border-radius: 50px;
    color: #ffffff;
    padding: 12px;
    font-size: 14px;
    font-weight: 700;
    align-self: center;
    cursor: pointer;
    flex: 1;
  }

  .custom-select {
    padding: 0;
  }

  .custom-select:hover {
    border: 1px solid #535353;
  }

  .phone-select {
    flex: 0;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-right: none;
    min-width: 70px;
    max-width: 70px;
  }

  .phone-input {
    flex: 3;
    border-radius: 5px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-left: none;
    padding-left: 0;
    min-width: 0;
  }

  .phone-code-input {
    flex: 0;
    border-radius: 0;
    border-right: none;
    padding-right: 0;
    width: 70px;
  }

  .label-wrapper {
    display: flex;
    justify-content: space-between;
    padding-right: 36px;
  }

  .group-container {
    display: flex;
    width: 100;
  }

  .big-label {
    font-size: 16px;
  }

  .image-names {
    color: #0d0d0e;
    padding-top: 24px;
    width: 100%;
  }

  .image-name {
    position: relative;
    background-color: #f2f2f3;
    width: fit-content;
    border-radius: 4px;
    padding: 8px 26px 8px 12px;
    min-width: 200px;
    font-size: 14px;
    font-weight: 400;
    margin-bottom: 12px;
    max-width: 100%;
    white-space: wrap;

    @media only screen and (max-width: 768px) {
      font-size: 12px;
    }
  }

  .link-container {
    margin: 24px 0 16px;
    gap: 62px;
    display: flex;
    flexdirection: row;
    width: 100%;
    padding: 0 60px;

    @media only screen and (max-width: 768px) {
      padding: 0 14px;
    }
  }

  .close-icon {
    position: absolute;
    right: 10px;
    top: 9px;
    cursor: pointer;
  }

  .close-icon-image {
    width: 16px;
    height: 16px;
  }

  .close-icon-image:hover {
    cursor: pointer;
  }

  .button-submit:hover {
    background: white;
    color: black !important;
  }

  .contact-us-submit-button:hover {
    background: #181818;
    color: white !important;
  }

  .dropzone-container,
  .text-area-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 10px;
    min-width: 300px;
  }

  .disabled-input {
    background-color: #ffffff;
    color: #c8c8c8;
  }

  .text-area {
    resize: vertical;
    min-height: 100px;

    ::-webkit-resizer {
      display: none;
    }
  }
`;
